// extracted by mini-css-extract-plugin
export default {"grid":"CardsGrid_grid__OvVeW"};